import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'app-auth',
	templateUrl: '../views/auth.component.html',
	styleUrls: ['../styles/auth.component.css']
})
export class AuthComponent implements OnInit {
	constructor() {}

	ngOnInit() {}
}
